export default {
  name: 'first',
  data: function() {
    return {}
  },
  props: ['water_heating', 'landingText'],
  computed: {

  },
  watch: {},
  methods: {
    goToSecond: function() {
      this.$emit('change-component', 'second-component', this.water_heating)
    },
    setNone: function() {
      this.water_heating.flow_heater = false
      this.water_heating.central_heating = false
      this.water_heating.boiler_w_pressure_comp = false
      this.water_heating.boiler_no_pressure_comp = false
    },
    unSetNone: function() {
      this.water_heating.none = false
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/first/first.js